// extracted by mini-css-extract-plugin
export default {"card":"MealsDeals_card__2MP-Q","mainImage":"MealsDeals_mainImage__DaqHt"};